import { render, staticRenderFns } from "./baseAttr.vue?vue&type=template&id=5e168b14&scoped=true"
import script from "./baseAttr.vue?vue&type=script&lang=js"
export * from "./baseAttr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e168b14",
  null
  
)

export default component.exports